import moment from 'moment';

export default function setToMaxHours(date: moment.Moment) {
  return date.set('hours', 23).set('minutes', 59).set('seconds', 59);
}
